import React, { useEffect, useState } from 'react';
import { InputGroup, FormControl, Badge } from 'react-bootstrap';
import './InputwithLabelComponent.css';
import Button from '../Button';
import InfoBar from '../InfoBars';
import VerifyIndex from '../../../pages/UserManagement/CreateNewUser/VerificationCard/verifyIndex';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/reducers';
interface Inputwithlabelprops {
  inputwithlabelPlaceholder: string;
  inputlabelPlaceholder: string;
  labelName?: string;
  inputlabeltype: string;
  inputlabelvalue?: any;
  disabled:boolean;
  verified:boolean;
  showVerifyLabel?:boolean;
  onChange: (value: string|boolean) => void;
  value?:any;
  required?:boolean,
  errorMessage?:string;
  inputType?:string;
  onClickVerify:(value: boolean)=>void;
  verifyMessage?:string;
  disabledButton?:boolean;
}
const InputWithLabel = ({
  inputwithlabelPlaceholder,
  inputlabelPlaceholder,
  labelName,
  inputlabeltype,
  inputlabelvalue,
  disabled,
  verified,
  showVerifyLabel,
  required,
  onChange,
  errorMessage,
  inputType,
  onClickVerify,
  verifyMessage,
  disabledButton=true
}: Inputwithlabelprops) => {
  const inputlabelChange=(e: React.ChangeEvent<HTMLInputElement>) =>{
    onChange(e.target.value);
    setVerify(false);
    setInputEntered(e.target.value.trim() !== '')
    setIsDisabledBtn(false) 
  }
  const [verify,setVerify]=useState<boolean>(false);
  const [displayVerify,setDisplayVerify]=useState<boolean>(false);
  const [displayNotVerify,setDisplayNotVerify]=useState<boolean>(false);
  const [inputEntered, setInputEntered] = useState<boolean>(false);
  const [isDisabledBtn, setIsDisabledBtn] = useState<boolean>(disabledButton);
  const handleClick=()=>{
    //onChange(true)
    setVerify(true);
   onClickVerify(true)
  };
  useEffect(()=>{

if(showVerifyLabel){
  if(verify===true && verified===true){
    setDisplayVerify(true);
    setDisplayNotVerify(false);

  }
  else if(verify===true && verified===false){
    setDisplayNotVerify(true);
    setDisplayVerify(false);
  }
}
  else{
    setDisplayNotVerify(false);
    setDisplayVerify(false);
  }
})
  return (
    <div className="ip-with-label">
      {labelName && (
        <label className={`label-name-required-for-ip ${required && 'yes'} `}>{labelName}</label>
      )}
      <div className="input-with-verify-button-main">
        <div className="input-with-button-verify">
          <InputGroup className="text-button-ip">
            <FormControl
              className="field-for-text-in-label"
              placeholder={inputwithlabelPlaceholder}
              onChange={inputlabelChange}
              type={inputlabeltype}
              value={inputlabelvalue}
              disabled={disabled}
            />
          </InputGroup>
         { displayVerify && verified &&(
             <button className="verified-button-for-in-label" disabled={true}>
             {verified?inputlabelPlaceholder:'Not Verified'}
           </button>)
          }
         { displayNotVerify && verified===false &&(
             <button className="verified-button-for-in-label-not-verified" disabled={true}>
             {verified?inputlabelPlaceholder:'Not Verified'}
           </button>)
          }
        </div>
        <div className={`verify-button-clickable-button ${verify}`}>
          <Button
            onClick={handleClick}
            disabled={isDisabledBtn}
            id=""
            buttonName={'Verify'}
            colorType={!isDisabledBtn? 'primary' : 'disabled'}
            icon={''}
            iconPosition={''}
          />
        </div>
      </div>
      <div className="input_field_infoBars">
        {inputType === 'success' ? (
          <InfoBar
            variant="success"
            message={errorMessage?errorMessage:'Success'}
            className="input_field_class"
          />
        ) : (
          ''
        )}
        {inputType === 'error' ? (
          <InfoBar
            variant="danger"
            message={errorMessage?errorMessage:''}
            className="input_field_class"
          />
        ) : (
          ''
        )}
      </div>
      {/* <div className="input_field_verify_infoBars">
        {displayVerify && verified &&(
          <InfoBar
            variant="success"
            message={'Success'}
            className="input_field_verify_class"
          />
        )}
        {displayNotVerify && verified===false &&(
          <InfoBar
            variant="danger"
            message={verifyMessage?verifyMessage:''}
            className="input_field_verify_class"
          />
        )}
      </div> */}
    </div>
  );
};
export default InputWithLabel;